import { cx } from '@mage-ui/styled-system/css';
import { navMenu } from '@mage-ui/styled-system/recipes';
import { NavItem } from '../nav-item/NavItem';

export const NavMenuLang = ({
	data,
	className,
	a11yLabel,
	currentLanguage,
	queryString,
	...props
}) => {
	const links = Array.isArray(data) ? data : [];
	const queryParamTranslations = {
		course: {
			ca: 'curs',
			es: 'curso',
			en: 'course',
		},
	};
	const getTranslatedQueryParam = (key, targetLanguage) => {
		const translation = Object.values(queryParamTranslations).find((values) =>
			Object.values(values).includes(key),
		);

		return translation?.[targetLanguage] || key;
	};
	const appendQueryString = (href, targetLanguage) => {
		if (!href || !queryString || href.startsWith('#')) {
			return href;
		}

		const [urlWithoutHash, hash = ''] = href.split('#');
		const [pathname, currentQueryString = ''] = urlWithoutHash.split('?');
		const currentParams = new URLSearchParams(queryString);
		const nextParams = new URLSearchParams(currentQueryString);

		currentParams.forEach((value, key) => {
			const translatedKey = getTranslatedQueryParam(key, targetLanguage);

			if (!nextParams.has(translatedKey)) {
				nextParams.append(translatedKey, value);
			}
		});

		const nextHref = `${pathname}?${nextParams.toString()}`;

		return hash ? `${nextHref}#${hash}` : nextHref;
	};

	return (
		<ul
			className={cx(navMenu().root, className)}
			aria-label={a11yLabel}
			{...props}
		>
			{links.map((link, index) => {
				return (
					<li key={link.meta?.key || index} className={navMenu().item}>
						<NavItem
							data={{
								...link,
								meta: {
									...link.meta,
									link: appendQueryString(link.meta?.link, link?.fields?.iso),
								},
								current: currentLanguage === link?.fields?.iso,
							}}
						/>
					</li>
				);
			})}
		</ul>
	);
};
